<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <p><strong>Номер телефона</strong></p>
          <div class="input-group">
            <input type="text" :disabled="localPhone.id" v-model="localPhone.phone_number" class="form-control">
            <div class="input-group-append">
              <template v-if="localPhone.id">
                <span class="input-group-text">{{ localPhone.operator }}</span>
              </template>
              <template v-else>
                <select v-model="localPhone.operator" class="form-control">
                  <option value="MTS">MTS</option>
                  <option value="beeline">beeline</option>
                </select>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group">
          <p><strong>Слот в GSM шлюзе</strong></p>
          <select v-model="localPhone.slot" class="form-control">
            <option v-for="index in 32" :value="index">{{ index }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <p><strong>Прикрепленные карты</strong></p>
        <div v-for="card in localPhone.cards" class="mb-1 border-bottom" :key="card.id">
          <p>{{ card.number }}</p>
          <p class="text-muted">{{ card.owner.name }}</p>
        </div>
      </div>
      <div class="col-md-4">
        <p><strong>Доступ к кабинету</strong></p>
        <div class="form-group">
          <label for="">Логин</label>
          <input type="text" v-model="localPhone.extra.login" class="form-control">
        </div>
        <div class="form-group">
          <label for="">Пароль</label>
          <input type="text" v-model="localPhone.extra.pass" class="form-control">
        </div>
      </div>
    </div>
    <div>
      <label><input type="checkbox" v-model="localPhone.is_active"> Номер телефона активен</label>
    </div>
    <div>
      <UploadImages ref="uploadedFiles" :files="localPhone.files" :blockUpload="true"/>
      <UploadCustomWithPreview
        :allowToUpload="!!localPhone.id"
        :extraData="{object: 'service_phones', objectId: localPhone.id}"
      />
    </div>
    <div class="mt-1 text-right">
      <LoadingButton
        title="Сохранить изменения"
        :loading="btnLoading"
        :color="$constants.SUCCESS_COLOR"
        :onClick="() => saveRecord()"
        className="btn btn-outline-success"
      />
    </div>
  </div>
</template>

<script>

import api from "@/api";
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview";
import UploadImages from "@/components/uploads/UploadImages";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['phone', 'callBackAction', 'closeDrawer'],
  components: {
    UploadCustomWithPreview,
    UploadImages,
    LoadingButton,
  },
  data() {
    return {
      btnLoading: false,
      localPhone: {}
    }
  },
  created() {
    if (this.phone && this.phone.id) {
      this.localPhone = {
        ...this.phone,
        extra: {
          login: null,
          pass: null,
          ...(this.phone.extra || {})
        }
      };
    } else {
      this.localPhone = {
        phone_number: null,
        operator: 'MTS',
        slot: 1,
        extra: {
          login: null,
          pass: null,
        }
      }
    }
  },
  methods: {
    async saveRecord() {
      if (!this.localPhone.phone_number) {
        toastr['warning']('Поле телефона не может быть пустым', 'Ошибка');
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/cards/phones', {
        record: this.localPhone,
        files: this.$refs.uploadedFiles.uploadedFiles
      })
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно');
        if (this.callBackAction) {
          this.callBackAction({...this.localPhone});
        }
        if (this.closeDrawer) {
          this.closeDrawer(null, true);
        }
      } else {
      }
      this.btnLoading = false;
    }
  }
}

</script>
